<script setup lang="ts">
import type { CarouselGenericActionVariants } from './index';

import { carouselButtonStyles } from './index';

defineOptions({ inheritAttrs: false });

type Props = {
	variant?: CarouselGenericActionVariants['variant'];
	padding?: CarouselGenericActionVariants['padding'];
	border?: CarouselGenericActionVariants['border'];
	background?: CarouselGenericActionVariants['background'];
};

const props = withDefaults(defineProps<Props>(), {
	variant: 'default',
	padding: 'none',
	border: 'none',
	background: 'transparent'
});
</script>

<template>
	<button
		v-bind="$attrs"
		:class="[
			carouselButtonStyles({
				variant: props.variant,
				padding: props.padding,
				border: props.border,
				background: props.background
			}),
			$attrs.class
		]"
	>
		<slot></slot>
	</button>
</template>
